import { render, staticRenderFns } from "./ComponentAlertHubPageProfile.vue?vue&type=template&id=18d5476e"
import script from "./ComponentAlertHubPageProfile.vue?vue&type=script&lang=js"
export * from "./ComponentAlertHubPageProfile.vue?vue&type=script&lang=js"
import style0 from "./ComponentAlertHubPageProfile.vue?vue&type=style&index=0&id=18d5476e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports